// Webinars page entry point

import { initSwiperWebinarsWithResize } from './swiper-webinars.js';

// ─── Swiper ───────────────────────────────────────────────────────────────────

initSwiperWebinarsWithResize();
